import CustomLexiconContainer from './CustomLexiconContainer';
export default CustomLexiconContainer;
